var api = angular.module('api', [ ]).factory('api', [ '$http', '$q', function($http, $q) {
	return {
		send: function(method, url, data, cbSuccess, cbError) {
			if (cbSuccess == undefined) {
				cbSuccess = function() {}
			}
			if (cbError == undefined) {
				cbError = function() {}
			}
			let q = $q.defer();

			return $http({
				timeout: q.promise,
				method: method.toUpperCase(),
				url: url,
				data: (method.toUpperCase() == 'POST' ? data : {})
			}).then(cbSuccess, cbError);
		}
	};
}]);

(function(){
	if (typeof define === 'function' && define.amd)
		define('api', function () { return api; });
	else if (typeof module !== 'undefined' && module.exports)
		module.exports = api;
	else
		window.api = api;
})();
